import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAction } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for deleting an Action.
 */
export const useDeleteAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call deleteAction.
     * @param {Pella.ProductionRequestAPI.Action['id']} id - The ID of the Action to delete.
     */
    mutationFn: (id) => deleteAction(id),
    onSuccess: () => {
      toast.success('Action deleted successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ACTION_DATA] });
    },
  });
};
